import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e874424"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plant-pict me-1" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { key: 0 }

import { plantsService } from '@/di/services'

interface Props {
  sunny: string,
  withName?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlantSunny',
  props: {
    sunny: null,
    withName: { type: Boolean, default: false }
  },
  emits: ["sunnyClicked"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'sunnyClicked', sunny: { sunny: string }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { sunny: string, withName: boolean };





function clicked () {
  emit('sunnyClicked', { sunny: props.sunny })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(plantsService).getSunnyInfo(props.sunny).imageSource,
      alt: __props.sunny,
      onClick: clicked
    }, null, 8, _hoisted_2),
    (__props.withName)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(plantsService).getSunnyInfo(props.sunny).name), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})